export default "__VITE_ASSET__dd4b0c76__"